import React from 'react';
import { Service, formatUsd } from '../data/catalog';
import '../styles/Branch.css';

interface ServiceCardProps {
  service: Service;
  onBuy: (service: Service) => void;
  /** Id of the service whose checkout is currently being created. */
  buyingId: string | null;
  revealDelay?: number;
}

const KIND_LABEL: Record<Service['kind'], string> = {
  single: 'Single service',
  block: '3-session block',
  combo: 'Combo',
  package: 'Programme',
  unlimited: 'Unlimited'
};

const ServiceCard: React.FC<ServiceCardProps> = ({ service, onBuy, buyingId, revealDelay = 0 }) => {
  const isBuying = buyingId === service.id;
  const savings = service.compareAtUsd ? service.compareAtUsd - service.priceUsd : 0;

  return (
    <article
      className={`service-card bracketed ${service.popular ? 'service-card-popular' : ''}`}
      data-reveal
      style={{ ['--reveal-delay' as string]: `${revealDelay}s` }}
    >
      <div className="service-kicker-row">
        <p className="service-kicker">{KIND_LABEL[service.kind]}</p>
        {service.popular && <span className="popular-chip">Most popular</span>}
      </div>

      <h3 className="service-name">{service.name}</h3>
      <p className="service-blurb">{service.blurb}</p>

      <ul className="check-list service-features">
        {service.features.map(feature => (
          <li key={feature}>{feature}</li>
        ))}
      </ul>

      <div className="service-foot">
        <p className="service-price">
          {service.compareAtUsd && (
            <span className="price-compare">{formatUsd(service.compareAtUsd)}</span>
          )}
          <span className="price">{formatUsd(service.priceUsd)}</span>
          {savings > 0 && <span className="save-chip">Save {formatUsd(savings)}</span>}
        </p>
        <button
          className="btn btn-buy"
          onClick={() => onBuy(service)}
          disabled={buyingId !== null}
        >
          {isBuying ? 'Opening checkout…' : `Buy for ${formatUsd(service.priceUsd)}`}
        </button>
      </div>
    </article>
  );
};

export default ServiceCard;
